import React from 'react';
import { useDaresFilter } from 'root/src/client/web/record/DropEvent/DaresFilter/DaresFilterProvider';
import { ArrowDropDownSharp } from '@mui/icons-material';
import { Checkbox } from 'root/src/client/v2/form/components/Checkbox';
import * as Accordion from '@radix-ui/react-accordion';
import Link from 'next/link';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { DROPS_ANALYTIC_EVENTS } from 'root/src/shared/drops/drops.analytics';
export const BattlePassFilter = React.memo(() => {
    const { state, options, onFilterChange } = useDaresFilter();
    if (!options.battlePasses.length) {
        return null;
    }
    const handleValueChange = (option) => {
        analyticsSendItem(DROPS_ANALYTIC_EVENTS.DROP_DARE_FILTERS, 'battle_pass');
        if (state.battlePasses.includes(option)) {
            onFilterChange(Object.assign(Object.assign({}, state), { battlePasses: state.battlePasses.filter(item => item !== option) }));
        }
        else {
            onFilterChange(Object.assign(Object.assign({}, state), { battlePasses: [...state.battlePasses, option] }));
        }
    };
    return (<Accordion.Root className="AccordionRoot" type="single" collapsible defaultValue="level">
			<Accordion.Item className="AccordionItem overflow-x-hidden" value="level">
				<Accordion.AccordionTrigger className="uppercase flex py-2 justify-between group w-full">
					<span className="flex w-full">
						Battle pass dares
					</span>
					<div className="flex flex-initial items-center gap-2">
						<Link href={routeUrls.battlePasses()}>
							<a className="underline capitalize text-light-4 cursor-pointer">See all</a>
						</Link>
						<ArrowDropDownSharp className="!transition !duration-200 -rotate-90 group-data-[state=open]:rotate-0"/>
					</div>
				</Accordion.AccordionTrigger>
				<Accordion.AccordionContent className="AccordionContent">
					<ul className="flex flex-col gap-2 p-4">
						{options.battlePasses.map((option) => {
            const isSelected = state.battlePasses.includes(option.value);
            return (<li key={option.value} className="flex flex-initial font-medium font-mono justify-between items-center gap-4">
									<label htmlFor={`battle-pass-${option.value}`} className="flex select-none gap-3 items-center">
										{option.label}
									</label>
									<Checkbox id={`battle-pass-${option.value}`} onCheckedChange={() => handleValueChange(option.value)} checked={isSelected}/>
								</li>);
        })}
					</ul>
				</Accordion.AccordionContent>
			</Accordion.Item>
		</Accordion.Root>);
});
